import request from '@/utils/request'

export function getDashboard() {
  return request({
    url: '/biz/giftcard/dashboard',
    method: 'get'
  })
}
